var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM8 10C8.35129 10.0002 8.63574 10.2854 8.63574 10.6367C8.63555 10.9879 8.35117 11.2723 8 11.2725C7.64866 11.2725 7.36347 10.988 7.36328 10.6367C7.36328 10.2853 7.64855 10 8 10ZM8.63574 9H7.36328V5H8.63574V9Z",
    fill: "#D8221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDefault);
export default __webpack_public_path__ + "static/media/error-default.91f4012b9c2cf0c07864e076b0c0cd63.svg";
export { ForwardRef as ReactComponent };